import React, {useContext} from 'react';
import {Grid, Typography} from '@mui/material';
import LocationFeatureList from './LocationFeatureList';
import ImageNotAvailablePlaceholder from '../ImageNotAvailablePlaceholder';
import InstantApprovalChip from './InstantApprovalChip';
import RequestSpaceChip from './RequestSpaceChip';
import LocationListItemImages from './LocationImages/LocationListItemImages';
import LocationItemPriceDisplay from '../LocationItemPriceDisplay';
import './style.css'
import {AiOutlineLeft, AiOutlineRight} from 'react-icons/ai'
import NotLiveLocationChip from "../../NotLiveLocationChip";
import LocationFavoriteIcon from '../LocationFavoriteIcon';
import {AppContext} from "../../../context/app-context";
import {isBuyerAccountType} from '../../../util/AccountUtils';
import {styled} from "@mui/material/styles";
import {useImageCarousel} from "../../../hooks/location/useImageCarousel";
import {getLocationGallery} from "../../../util/LocationMediaUtils";

const LocationListDistance = styled(Typography)(() => ({
  fontSize: '1.14rem',
  fontFamily: 'Inter, sans-serif',
  fontWeight: 500
}));

const LocationListItem = (props) => {
  const appContext = useContext(AppContext)
  const { location, showVisibilityChip, setListHover, isFavorite } = props;
  const listingImage = location?.listingImageFileName;
  const gallery = getLocationGallery(location);
  const distance = location?.distance;

  // Total images = listing image (if exists) + gallery images
  const totalImages = (listingImage ? 1 : 0) + gallery.length;

  const { activeSlide, prevImage, nextImage } = useImageCarousel({ totalImages });

  const { locationName } = location;
  let locationDescription = locationName ? locationName : `${location.city}, ${location.state}`;

  return (
    <div className='ss-listing-card' onMouseEnter={() => setListHover && setListHover(location)} onMouseLeave={() => setListHover && setListHover(null)}>
      <Grid item className='ss-listing-thumnail'>
        {
          listingImage ?
            <LocationListItemImages
              errorimg='/app-images/not-found-image/place_holder_image.png'
              placeholderimg="/app-images/loading/image-loader.gif"
              activeSlide={activeSlide}
              listingImageFileName={listingImage}
              gallery={gallery}
              locationId={location?.locationId}
            /> :
            <ImageNotAvailablePlaceholder />
        }
        {totalImages > 1 &&
          <>
            <button disabled={activeSlide === 0} onClick={prevImage} className='ss-left-side-button'>
              <AiOutlineLeft size={25} color={`${activeSlide === 0 ? "#2E363E" : "black"}`} />
            </button>
            <button disabled={activeSlide === totalImages - 1} onClick={nextImage} className='ss-right-side-button'>
              <AiOutlineRight size={25} color={`${activeSlide === totalImages - 1 ? "#2E363E" : "black"}`} />
            </button>
          </>
        }
      </Grid>

      <Grid container direction={'column'} wrap={'nowrap'} className={"ss-profile-details"}>
        <Grid item>
          <Grid container direction={'row'} wrap='nowrap' justifyContent='space-between' alignItems='center'>
            <Grid item>
              <Grid container direction={'row'} spacing={2}>
                {
                  location?.hasInstantApproval ?
                    <Grid item><InstantApprovalChip /></Grid> :
                    <Grid item><RequestSpaceChip /></Grid>
                }
                {
                  showVisibilityChip && !location?.visible && <Grid item><NotLiveLocationChip /></Grid>
                }
              </Grid>
            </Grid>
            <Grid item><LocationListDistance>{distance} mi</LocationListDistance></Grid>
          </Grid>
        </Grid>
        <Grid item>
          <Grid container direction={'row'} wrap='nowrap' justifyContent='space-between' alignItems='center'>
            <Grid item mt={-0.5}>
              <Typography className='ss-listing-title'>{locationDescription}</Typography>
            </Grid>
            {
              isBuyerAccountType(appContext?.user?.type) &&
              <Grid item>
                <LocationFavoriteIcon locationId={location.locationId} isFavorite={isFavorite} />
              </Grid>
            }
          </Grid>
        </Grid>
        <Grid item className={'ss-spacer'} mt={-0.5}>
          <LocationFeatureList maxFeatures={4} features={location?.features} />
        </Grid>

        <Grid item>
          <LocationItemPriceDisplay
            pricePerMonth={location?.pricePerMonth ? location.pricePerMonth : 0}
            pricePerDay={location?.pricePerDay ? location.pricePerDay : 0}
          />
        </Grid>
      </Grid>
    </div>
  )
}

export default LocationListItem;
